import Amplify, { Auth } from 'aws-amplify';

import config from '@config';

export const configure = () => {
  Amplify.configure({ Auth: config.aws.auth });
  Auth.configure({ oauth: config.aws.oauth });
};

let cachedIdToken;

export const signIn = () => Auth.federatedSignIn();

export const signOut = async () => {
  try {
    const result = await Auth.signOut({ global: true });
    return result;
  } catch (e) {
    console.log(e);
  }
  window.localStorage.clear();
  cachedIdToken = null;
  return null;
};

export const getSession = async () => {
  try {
    const session = await Auth.currentSession();
    return session;
  } catch (err) {
    return null;
  }
};

export const getUser = async () => {
  try {
    const user = await Auth.currentAuthenticatedUser();
    return user;
  } catch (err) {
    return null;
  }
};

export const verifySignIn = async () => {
  const session = await getSession();

  if (!session) signIn();
};

const hasTokenExpired = (idToken) => idToken.getExpiration() < Date.now() / 1000;

export const getJwtToken = async () => {
  if (!cachedIdToken || hasTokenExpired(cachedIdToken)) {
    const session = await getSession();
    cachedIdToken = session?.getIdToken();
  }

  return cachedIdToken?.getJwtToken() ?? null;
};

export const injectJwtToken = async (request, { prefix } = {}) => {
  const jwtToken = await getJwtToken();

  if (jwtToken) {
    request.headers.set('Authorization', prefix ? `${prefix} ${jwtToken}` : jwtToken);
  }
};

export const changePassword = async (currentPassword, newPassword) => {
  const user = await getUser();
  return Auth.changePassword(user, currentPassword, newPassword);
};

export const changeAttributes = async (attributes) => {
  const user = await getUser();
  return Auth.updateUserAttributes(user, attributes);
};
